<template>
  <div class="timetable-column-header">
    <popover-menu>
      <template v-slot:trigger="{ listenerObject }">
        <button
          class="timetable-column-header__column"
          type="button"
          v-bind:disabled="popoverDisabled"
          v-on:click.stop="onClickTitle"
          v-on="listenerObject">
          <span
            class="timetable-column-header__title"
            v-bind:title="titleHoverText">{{ title }}</span>
          <span class="timetable-column-header__subtitle">{{ subtitle }}</span>
        </button>
      </template>
      <slot />
    </popover-menu>
    <popover-menu
      v-if="!isMobile && showPopoverPrintDialog"
      custom-class="hide-phone-popover"
      offset-x
      v-bind:close-on-content-click="false"
      v-model="isShownPrintDialog"
    >
      <div class="hide-phone-popover__content">
        <input-checkbox
          v-if="isAdmin"
          name="is-hide-phone"
          title="Скрыть номер телефона пациента"
          v-model="hidePhone"
        />
        <input-checkbox
          name="print-free-slots"
          title="Печатать свободные слоты"
          v-model="printFreeSlots"
        />
        <button
          class="hide-phone-popover__button"
          type="button"
          v-on:click="dispatchPrint"
        >
          Печать
        </button>
      </div>
      <template v-slot:trigger="{ listenerObject }">
        <button
          type="button"
          class="timetable-column-header__print"
          title="Печать расписания"
          v-on="listenerObject"
        />
      </template>
    </popover-menu>
    <button
      v-else-if="!isMobile"
      class="timetable-column-header__print"
      title="Печать расписания"
      type="button"
      v-on:click="dispatchPrint" />
  </div>
</template>

<script>
import mobileMixin from '@/mixins/mobileMixin';
import InputCheckbox from './InputCheckbox.vue';
import PopoverMenu from './PopoverMenu.vue';

/**
 * @description Название события печати колонки.
 * @type {string}
 */
const NAME_EVENT_PRINT_COLUMN = 'print-column';

export default {
  components: { PopoverMenu, InputCheckbox },
  computed: {
    isAdmin() {
      return this.$store.getters.getUserRole === 'admin';
    },
  },
  data() {
    return {
      isShownPrintDialog: false,
      hidePhone: false,
      printFreeSlots: false,
    };
  },
  methods: {
    /**
     * @description Обработать нажатие на заголовок.
     * @returns {void}
     */
    onClickTitle() {
      this.$emit('click-on-title');
    },
    /**
     * @description Отправить событие печати столбца.
     * @returns {void}
     */
    dispatchPrint() {
      this.$emit(
        NAME_EVENT_PRINT_COLUMN,
        { hidePhone: this.hidePhone, printFreeSlots: this.printFreeSlots },
      );
      this.closeDialog();
    },
    /**
     * @description Закрыть модальное окно.
     * @returns {void}
     */
    closeDialog() {
      this.isShownPrintDialog = true;
      this.$nextTick(() => {
        this.isShownPrintDialog = false;
        this.printFreeSlots = false;
      });
    },
  },
  props: {
    /**
     * @description Деактивировать диалоговое меню.
     */
    popoverDisabled: { default: () => false, type: Boolean },
    /**
     * @description Подзаголовок.
     * @type {string}
     */
    subtitle: { default: '', type: String },
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: { type: String, required: true },
    /**
     * @description Текст при наведении на заголовок.
     * @type {string}
     */
    titleHoverText: { type: String, default: '' },
    /**
     * @description Показывать диалоговое окно печати.
     * @returns {Boolean}
     */
    showPopoverPrintDialog: { default: () => false, type: Boolean },
  },
  mixins: [
    mobileMixin,
  ],
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.hide-phone-popover {
  &__content {
    display: grid;
    row-gap: 10px;
    padding: 20px;
  }
  &__button {
    @include buttons.btn-blue(130px, 34px, 16px);
    justify-self: end;
  }
}
.timetable-column-header {
  cursor: pointer;
  background-color: #ffffff;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 30px;
  grid-gap: 10px;
  width: 100%;
  padding: 0 9px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
  height: 61px;
  min-height: 61px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-top: none;
  &__column {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 5px;
    text-align: inherit;
  }
  &__print {
    width: 30px;
    height: 30px;
    background-color: #eaeff3;
    border-radius: 4px;
    background-image: url("@/assets/img/print-grey.svg");
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    &:hover {
      background-image: url("@/assets/img/print.svg");
    }
  }
  &__title {
    color: #0489e0;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    margin: 4px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
    width: fit-content;
    border-bottom: 1px dashed;
    &:hover {
      border-bottom-color: transparent;
    }
  }
  &__subtitle {
    color: #707683;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
  }
}
@media screen and (max-width: 480px) {
  .timetable-column-header {
    grid-template-columns: 1fr;
    &__print {
      display: none;
    }
    &__title,
    &__subtitle {
      max-width:none;
    }
  }
}
</style>
